<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17rj88D/tc-custom/9781466860407.jpg?1731184708445" alt="This image is the cover for the book Rough Justice, The Sinner's Tribe Motorcycle Club"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rough Justice, The Sinner's Tribe Motorcycle Club
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From <i>New York Times </i>bestselling author Sarah Castille comes <i>Rough Justice, </i>a scorching new series featuring red-hot, hard-riding bikers and the women who can't help but love them…</b><br/><b>IT TAKES A GOOD, STRONG WOMAN </b><br/>Raised in a motorcycle gang, tough, beautiful Arianne Wilder has always dreamed of a normal life. But no sooner does she escape her father's domineering grasp than she wakes up to find herself in a rival gang's clubhouse—at the mercy of the dangerously sexy Jagger Knight.<br/><b>TO TAME A MAN WHO'S HELL ON WHEELS.</b><br/>The alpha leader of the notorious Sinner's Tribe, Jagger Knight is all muscle, all biker, and all man. But somewhere inside this hard, tattooed outlaw, Arianne senses a kindred spirit—and she can't ignore their tempestuous attraction. Can she beat him at his own game in a revved-up blaze of glory? Or will their passion spark a war that's the end of the road for them both?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Castille
      </h2>
      
      <p class="authorDescription body article"><I>New York Times</I> and <I>USA Today </I>bestselling author of the dark, gritty biker romance, <I>Rough Justice</I>, Sarah Castille, worked and travelled abroad before trading her briefcase and stilettos for a handful of magic beans and a home near the Canadian Rockies. She writes contemporary erotic romance and romantic suspense featuring blazingly hot alpha heroes and the women who tame them.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Paperbacks
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c584bc76